import React, { useEffect, useRef, useState } from 'react';
import { industriesData } from '../../data/mock';
import { Factory } from 'lucide-react';

const IndustriesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-16 md:py-20 overflow-hidden"
      style={{ background: 'white' }}
    >
      <div className="container">
        <div className="text-center mb-10">
          <div 
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4 ${
              isVisible ? 'animate-fadeInUp' : 'opacity-0'
            }`}
            style={{ background: 'var(--brand-primary)', color: 'var(--brand-dark)' }}
          >
            <Factory size={16} />
            <span className="font-semibold text-sm">Industries</span>
          </div>
          <h3 
            className={`heading-2 ${isVisible ? 'animate-fadeInUp stagger-1' : 'opacity-0'}`}
            style={{ color: 'var(--text-primary)' }}
          >
            {industriesData.title}
          </h3>
        </div>

        {/* Scrolling Industries */}
        <div className="relative">
          {/* Gradient overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />
          
          <div className={`flex gap-4 animate-scroll ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            {[...industriesData.industries, ...industriesData.industries].map((industry, index) => (
              <div 
                key={index}
                className="flex-shrink-0 px-6 py-3 rounded-full whitespace-nowrap transition-all duration-300 hover:scale-105"
                style={{ 
                  background: 'var(--bg-page)',
                  color: 'var(--text-primary)'
                }}
              >
                <span className="font-medium">{industry}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default IndustriesSection;
